import { render, staticRenderFns } from "./DepositRialDetail.html?vue&type=template&id=3fb77496&scoped=true&"
import script from "./DepositRialDetail.js?vue&type=script&lang=js&"
export * from "./DepositRialDetail.js?vue&type=script&lang=js&"
import style0 from "./DepositRialDetail.scss?vue&type=style&index=0&id=3fb77496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb77496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
